window.onload = (e) => {

    const modalOverlay = document.querySelector('#b107-modal-overlay');
    const modalTriggers = document.querySelectorAll('.b107-bio-modal-trigger');
    const modalCloseBtns = document.querySelectorAll('.b107-modal-close');
    let currentOpen = null;

    function closeModal(modal) {
        modalOverlay?.classList.remove('show');
        modal.classList.add('hide');

        setTimeout(() => {
            modal.classList.remove('show','hide');
            currentOpen = null;
        }, 500);
    }

    modalTriggers.forEach((el) => {
        el.addEventListener('click', (e) => {
            modalOverlay?.classList.add('show');
            el.nextElementSibling?.classList.add('show');
            currentOpen = el.nextElementSibling;
        })
    });
    modalCloseBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            let toClose = el.closest('.b107-modal');
            closeModal(toClose);
        })
    });
    document.addEventListener('click', (e) => {
        if (currentOpen && e.target === modalOverlay) {
            closeModal(currentOpen);
        }
    });

}